var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V4.35L4.4 6.95L3 5.5L8 0.5L13 5.5L11.6 6.95L9 4.35V12.5H7ZM2 16.5C1.45 16.5 0.979333 16.3043 0.588 15.913C0.196666 15.5217 0.000666667 15.0507 0 14.5V11.5H2V14.5H14V11.5H16V14.5C16 15.05 15.8043 15.521 15.413 15.913C15.0217 16.305 14.5507 16.5007 14 16.5H2Z",
    fill: "#6E7173"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBlack);
export default __webpack_public_path__ + "static/media/upload_black.b837e7c034b2894a03b58bdc6616415c.svg";
export { ForwardRef as ReactComponent };